import { createElement } from "react";
import Box from "@mui/material/Box";
import { ConfirmAlert } from "./Alerts";
import OrganicPublishRetryFailuresTable from "./OrganicPublishRetryFailuresTable";
import {
  BUTTON_CANCEL,
  BUTTON_RETRY,
  ORGANIC_PUBLISH_RETRY_CONFIRM_DESCRIPTION,
  ORGANIC_PUBLISH_RETRY_CONFIRM_TITLE,
} from "../../i18n/keysTranslations";

export const confirmOrganicPublishRetry = async ({
  rows = [],
  platformsLabel = "",
  t,
}) => {
  if (rows.length > 0) {
    return ConfirmAlert({
      title: t(ORGANIC_PUBLISH_RETRY_CONFIRM_TITLE),
      text: "",
      html: createElement(
        Box,
        {
          sx: {
            width: "100%",
            maxHeight: "400px",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            justifyContent: "center",
            alignItems: "center",
          },
        },
        createElement(OrganicPublishRetryFailuresTable, { rows })
      ),
      width: "min(560px, 94vw)",
      confirmButtonText: t(BUTTON_RETRY),
      cancelButtonText: t(BUTTON_CANCEL),
    });
  }

  return ConfirmAlert({
    title: t(ORGANIC_PUBLISH_RETRY_CONFIRM_TITLE),
    text: t(ORGANIC_PUBLISH_RETRY_CONFIRM_DESCRIPTION, {
      platforms: platformsLabel,
    }),
    confirmButtonText: t(BUTTON_RETRY),
    cancelButtonText: t(BUTTON_CANCEL),
  });
};
